import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useGetSignedUrlQuery } from "src/api/services/bucketApi";
import { SmsMedia } from "src/api/types";
import Spinner from "src/components/Spinner";

interface ImageViewProps {
  media: SmsMedia;
}

const MediaView = ({ media }: ImageViewProps) => {
  const { data, isLoading } = useGetSignedUrlQuery({
    path: media.storage_path,
    folder: "patients",
  });

  if (isLoading === true) {
    return <Spinner />;
  }

  if (data == null) {
    return <Typography>Failed to fetch image</Typography>;
  }

  return (
    <Link to={data} target="_blank">
      <img src={data} alt="image" width={"100%"} />
    </Link>
  );
};

export default MediaView;
